import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class IndexedDbService {
  private dbReady: Promise<void>;
  private db: IDBDatabase;

  constructor() {
    this.connectToDb();
  }

 private connectToDb(): void {
  this.dbReady = new Promise((resolve, reject) => {
    const request = indexedDB.open('sapmpDB', 1);

    request.onupgradeneeded = (event: any) => {
      this.db = event.target.result;
      this.db.createObjectStore('devices', { autoIncrement: true });
    };

    request.onsuccess = (event: any) => {
      this.db = event.target.result;
      resolve();
    };

    request.onerror = (event: any) => {
      console.log('Database error: ' + event.target.errorCode);
      reject('Error opening database');
    };
  });
  }

  getDb(): Promise<IDBDatabase> {
    return this.dbReady.then(() => this.db);
  }

  addData(storeName: string, data: any): void {
    const transaction = this.db.transaction([storeName], 'readwrite');
    const objectStore = transaction.objectStore(storeName);
  
    const countRequest = objectStore.count();
    countRequest.onsuccess = () => {
      if (countRequest.result < 1) {
        const addRequest = objectStore.add(data);
        addRequest.onsuccess = () => {
          console.log('Data added successfully');
        };
        addRequest.onerror = () => {
          console.log('Error adding data');
        };
      } else {
        console.log('Data is already present in the db!');
      }
    };
  }
  // ...

  getData(storeName: string, key: IDBValidKey): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const transaction = this.db.transaction([storeName]);
      const objectStore = transaction.objectStore(storeName);
      const request = objectStore.get(key);

      request.onsuccess = (event: any) => {
        resolve(request.result);
      };

      request.onerror = (event: any) => {
        console.log('Error getting data');
        reject(event);
      };
    });
  }

  getAllData(storeName: string): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {

      if (!this.db) {
        reject('DB is not initialized');
        return;
      }

      const transaction = this.db.transaction([storeName]);
      const objectStore = transaction.objectStore(storeName);
      const request = objectStore.getAll();
  
      request.onsuccess = (event: any) => {
        resolve(request.result);
      };
  
      request.onerror = (event: any) => {
        console.log('Error getting all data');
        reject(event);
      };
    });
  }

  closeConnection(): void {
    if (this.db) {
      this.db.close();
      this.db = null;
    }
  }

  clearData(storeName: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const transaction = this.db.transaction([storeName], 'readwrite');
      const objectStore = transaction.objectStore(storeName);
      const request = objectStore.clear();
  
      request.onsuccess = () => {
        resolve();
      };
  
      request.onerror = (event: any) => {
        console.log('Error clearing data');
        reject(event);
      };
    });
  }
}
